/**
 * La Batterie (author's addition): thrown like a grenade, it stays where it comes to rest and, at the start of each of
 * the next BATTERY_TURNS turns, discharges (its radius, and the water connected to it: its damage once to each unit
 * there): the electricity of Robotman's carcass, in a box. It falls with the terrain; an explosion destroys it. In the
 * sandbox (no turns) it discharges every BATTERY_SANDBOX_TICKS.
 */
import { STATE_LIQUID } from '@invaders/sim';
import { TICKS_PER_SECOND, type GameState, type Battery } from './state';
import { WEAPONS } from './weapons';
import { WEAPON_BATTERY } from './weapon-ids';
import { discharge } from './cold';
import { ownerPlayer } from './unit';

export const BATTERY_TURNS = 4;
export const BATTERY_SANDBOX_TICKS = 3 * TICKS_PER_SECOND;
/** Half size of a battery, for its fall and its drawing. */
export const BATTERY_HALF = 2;

export function placeBattery(state: GameState, x: number, y: number, owner: number): void {
  state.batteries.push({ x, y, owner, turns: BATTERY_TURNS, tick: 0 });
}

/** A discharge of the battery: its owner's team's blow (friendly fire). */
function zap(state: GameState, b: Battery): void {
  const weapon = WEAPONS[WEAPON_BATTERY];
  state.source = ownerPlayer(state, b.owner);
  discharge(state, b.x, b.y, weapon.radius, weapon.damage);
  state.source = -1;
}

/** Start of a turn (match): every battery discharges, then has one turn less. */
export function batteriesTurnStart(state: GameState): void {
  for (let i = state.batteries.length - 1; i >= 0; i--) {
    const b = state.batteries[i];
    zap(state, b);
    if (--b.turns <= 0) state.batteries.splice(i, 1);
  }
}

/** Every tick: they fall with the terrain (one cell per tick); in the sandbox, the discharges come with time. */
export function updateBatteries(state: GameState): void {
  const { w, h, data } = state.world.physique;
  const matState = state.world.rules.materials.state;
  for (let i = state.batteries.length - 1; i >= 0; i--) {
    const b = state.batteries[i];
    const below = b.y + BATTERY_HALF + 1;
    if (below >= h) { state.batteries.splice(i, 1); continue; }
    if (matState[data[below * w + b.x]] >= STATE_LIQUID) b.y++;
    if (state.match || ++b.tick < BATTERY_SANDBOX_TICKS) continue;
    b.tick = 0;
    zap(state, b);
    if (--b.turns <= 0) state.batteries.splice(i, 1);
  }
}

/** An explosion destroys the batteries in its radius. */
export function blastBatteries(state: GameState, cx: number, cy: number, radius: number): void {
  for (let i = state.batteries.length - 1; i >= 0; i--) {
    const b = state.batteries[i];
    if ((b.x - cx) * (b.x - cx) + (b.y - cy) * (b.y - cy) <= radius * radius) state.batteries.splice(i, 1);
  }
}
